import { type ReactHTML } from 'react'
import { type DashFontSize, dashFontSizeElementMapping } from '../../foundation/typography'

export const resolveDashTextElementType = (fontSize: DashFontSize): keyof ReactHTML =>
  dashFontSizeElementMapping[fontSize]
